import BodyLayout from "../../layouts/BodyLayout";
import Title from "../Title";
import { Stack, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

type FormItem = {
  name: string;
  link: string;
};

type Props = {};

const Forms = (props: Props) => {
  // Just a flat list of forms
  const forms: FormItem[] = [
    {
      name: "All Applications",
      link: "/assets/pdf/download/forms/All Applications.pdf",
    },
    {
      name: "Application for Change in Date of Birth",
      link: "/assets/pdf/download/forms/Application for Change in Date of Birth.pdf",
    },
    {
      name: "Application for Change in Name",
      link: "/assets/pdf/download/forms/Application for Change in Name.pdf",
    },
     {
      name: "Application for Change in Caste & Sub Caste",
      link: "/assets/pdf/download/forms/Application for Change in Caste & Sub Caste.pdf",
    },
  ];

  return (
    <BodyLayout>
      <Title title="Downloads" />

      <Stack mt={5} spacing={2}>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Latest Forms
        </Typography>

        {forms.length > 0 ? (
          forms.map((item, idx) => (
            <Stack
              key={idx}
              direction="row"
              alignItems="center"
              spacing={1}
              mb={1}
              sx={{
                backgroundColor: "#f9f9f9",
                padding: "8px 12px",
                borderRadius: "6px",
                transition: "all 0.2s ease-in-out",
                "&:hover": { backgroundColor: "#f1f1f1" },
              }}
            >
              <DescriptionIcon color="action" fontSize="small" />
              <Typography
                component="a"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "primary.main",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {item.name}
              </Typography>
            </Stack>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No forms available at the moment.
          </Typography>
        )}
      </Stack>
    </BodyLayout>
  );
};

export default Forms;
